import React, { useEffect, useState } from "react";
import "../../styles/aboutus.css";
import aboutushero from "../../assets/images/aboutus/aboutushero/aboutushero.jpg";
import { aboutUs } from "../../data/aboutUs";

const TYPING_SPEED_MS = 25;

const AboutUsHero = () => {
  const { heading, description } = aboutUs.hero;
  const paragraphs = [description, ...aboutUs.intro.paragraphs];
  const fullHeadingText = heading.join("\n");

  const [typedLength, setTypedLength] = useState(0);
  const [paragraphsVisible, setParagraphsVisible] = useState(false);

  useEffect(() => {
    if (typedLength >= fullHeadingText.length) return undefined;
    const timeout = setTimeout(
      () => setTypedLength((len) => len + 1),
      TYPING_SPEED_MS
    );
    return () => clearTimeout(timeout);
  }, [typedLength, fullHeadingText]);

  // Paragraphs fade in while the tagline types, not after it, so the page
  // doesn't sit half-empty for the length of the typing.
  useEffect(() => {
    const timeout = setTimeout(() => setParagraphsVisible(true), 300);
    return () => clearTimeout(timeout);
  }, []);

  const typedLines = fullHeadingText.slice(0, typedLength).split("\n");

  return (
    <>
    <section className="aboutus_hero_bg">
      <div className="aboutus_hero_glow_orb" />
      <div className="aboutus_hero_glow_orb aboutus_hero_glow_orb--left" />

      <div className="container-fluid position-relative z-1 aboutus_hero_container">
        <div className="row align-items-center g-4">
          <div
            className="col-12 col-lg-8 text-center text-lg-start"
            style={{ zIndex: 4, position: "relative" }}
          >
            <h1 className="aboutus_hero_pagetitle">
              About{" "}
              <span className="aboutus_hero_pagetitle_accent">HKI Media</span>
            </h1>

            <h2 className="aboutus_hero_tagline" aria-label={heading.join(" ")}>
              <span aria-hidden="true">
                {typedLines.map((line, index) => (
                  <span
                    className={`d-block aboutus_hero_tagline_line aboutus_hero_tagline_line-${index}`}
                    key={index}
                  >
                    {line}
                    {index === typedLines.length - 1 && (
                      <span className="aboutus_hero_cursor" />
                    )}
                  </span>
                ))}
              </span>
            </h2>

            <div
              className={`aboutus_hero_paragraphs ${
                paragraphsVisible ? "is-visible" : ""
              }`}
            >
              {paragraphs.map((paragraph, index) => (
                <p
                  className="aboutus_hero_description"
                  style={{ transitionDelay: `${index * 0.12}s` }}
                  key={index}
                >
                  {paragraph}
                </p>
              ))}
            </div>
          </div>

          <div className="col-12 col-lg-4 mt-4 mt-lg-0">
            <div className="aboutus_hero_image_wrapper">
              <img
                src={aboutushero}
                className="aboutus_hero_image floating-img"
                alt="HKI Media - hand holding a camera"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    {/* .aboutus_hero_bg is position:fixed (see aboutus.css) so it never
        scrolls at all — this reserves its height in normal document flow so
        Origin Story starts right below it instead of underneath it. */}
    <div className="aboutus_hero_spacer" aria-hidden="true" />
    </>
  );
};

export default AboutUsHero;
